<div id="new-location-wrapper" data-cy="new-location-wrapper">
  <ep-location-form-card
    title="New Location"
    mode="add"
    [isSaving]="isSaving"
    [isSaveDisabled]="(isSaveDisabled$ | async) === true"
    (save)="saveLocation()"
  >
    <app-location-form></app-location-form>
  </ep-location-form-card>
</div>
